import React from 'react';
import classnames from 'classnames';
import { I as Icon } from './Icon-8KKXFsxm.js';

var styles = {"banner":"meuT8gYQPJU-","bannerChildren":"y4BapyZr-fo-","bannerContent":"_6v1woNSLEvc-","medium":"bocgLmEhcTU-","bannerAction":"rtNjEzmABX4-","closeButton":"lunQ5SOfyLg-","iconWrapper":"SG8xSJADp2k-"};

var iconStyles = {"success":"_5-B0X5vn0eA-","error":"r3hqur-vxwI-","warning":"-c8TbjyV5YU-","notice":"bMc69fYWngM-"};

function BannerIcon({ icon, type }) {
    return (React.createElement("span", { className: classnames(styles.iconWrapper, iconStyles[type]) },
        React.createElement(Icon, { name: icon, color: "surface", size: "small" })));
}

export { BannerIcon as B, styles as s };
